import React, { useEffect, useState } from "react";
import { courseURL, lessonsURL, sessionsClassesURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import { useNavigate, useParams } from "react-router-dom";
import ClassSessionDetails from "../../Templates/Sessions/ClassSessionDetails/ClassSessionDetails";
import useDelete from "../../Hooks/useDelete";
import useFetchWhen from "../../Hooks/useFetchWhen";

function ClassSessionDetailsPage() {
  let { id, session_id } = useParams();
  const navigate = useNavigate();

  const url = `${sessionsClassesURL(id)}/${session_id}`;
  const TasksUrl = `${sessionsClassesURL(id)}/${session_id}/tasks`;

  const [taskOpen, setTaskOpen] = useState(false);

  const [sessionData, setSessionData] = useState({});
  const { data, loading, error } = useFetch(url);

  const [lesson, setLesson] = useState({});
  const {
    data: lessonData,
    loading: lessonLoading,
    error: lessonError,
  } = useFetchWhen(
    `${courseURL}/${sessionData?.class?.course?.id}/lessons/${sessionData?.lesson?.id}`,
    sessionData?.lesson?.id
  );

  const [go, setGo] = useState(false);
  const { deleteRes, loading: DeleteLoading } = useDelete(
    `${sessionsClassesURL(id)}/${session_id}`,
    go,
    `classes/${id}/sessions`
  );

  const [goTask, setGoTask] = useState(false);
  const { deleteRes: DeleteResTask, loading: TaskDeleteLoading } = useDelete(
    TasksUrl,
    goTask,
    "",
    { function: setSessionData },
    url
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setSessionData(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!lessonLoading && !lessonError && lessonData) {
      setLesson(lessonData.data);
    }
  }, [lessonData, lessonLoading, lessonError]);

  return (
    <ClassSessionDetails
      sessionData={sessionData}
      loading={loading}
      taskOpen={taskOpen}
      setTaskOpen={setTaskOpen}
      url={TasksUrl}
      FetchUrl={url}
      setGo={setGo}
      setGoTask={setGoTask}
      DeleteLoading={DeleteLoading}
      TaskDeleteLoading={TaskDeleteLoading}
      setSessionData={setSessionData}
      classId={id}
      lesson={lesson}
    />
  );
}

export default ClassSessionDetailsPage;
